import React from 'react'
import { useHistory } from 'react-router-dom'
import EmptyStateSearch from '../emptyStateSearch/EmptyStateSearch'

import './searchResultsBar.css'

const SearchResultsBar = ({results, following}) => {

  const PF = process.env.REACT_APP_PUBLIC_FOLDER

  const history = useHistory()

  results.sort((result1, result2) => following.includes(result2._id) - following.includes(result1._id))

  const handleClick = (username) => {
    history.push(`/profile/${username}`)
  }

  return (
    <div className="searchResults">
      <div className="searchResultsWrapper">
        {
          results.length === 0
          ?
          <EmptyStateSearch />
          :
          results.map(result => (   
              <div className="result" onMouseDown={(e) => e.preventDefault()} onClick={() => handleClick(result.username)}>
                <div className="resultsLeft">
                  <div className="resultuserprofilePictureContainer">
                    <img className="rightbarProfileImg" src={result.profilePicture || (PF + "person/default_avatar.jpg") } alt="" />
                  </div>
                  <div className="resultuserInfo">
                    <div className="resultusername">
                      {result.username}
                    </div>
                    <div className="resultuseremail">
                      {result.email}
                    </div>
                  </div>
                </div>
                {
                  following.includes(result._id) && "Friend"
                }
              </div>
          ))
        }
      </div>
    </div>
  )
}

export default SearchResultsBar